import React, { useMemo, useState } from "react";
import { GoogleMap, Marker, InfoWindow, useLoadScript } from "@react-google-maps/api";

export default function MobilityMap({ points = [], centerFallback = { lat: 41.04, lng: 28.99 }, zoom = 12 }) {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyCaHzltTBFsM9LOb9EDlMHdUV-m1Od0hF4",
  });

  const [active, setActive] = useState(null);

  const center = useMemo(() => {
    if (!points.length) return centerFallback;
    const valid = points.filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));
    if (!valid.length) return centerFallback;
    const sum = valid.reduce((acc, p) => ({ lat: acc.lat + p.lat, lng: acc.lng + p.lng }), { lat: 0, lng: 0 });
    return { lat: sum.lat / valid.length, lng: sum.lng / valid.length };
  }, [points, centerFallback]);

  const infoOpts = useMemo(() => {
    if (!isLoaded || !window?.google?.maps) return undefined;
    return { maxWidth: 280, pixelOffset: new window.google.maps.Size(0, -8) };
  }, [isLoaded]);

  if (!isLoaded) return <div>Harita yükleniyor…</div>;

  const cardStyle = { maxWidth: 260, display: "grid", gap: 8, fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif" };
  const imgStyle = { width: "100%", height: 140, objectFit: "cover", borderRadius: 8, display: "block" };
  const titleStyle = { margin: 0, fontSize: 16, fontWeight: 600 };

  return (
    <div style={{ height: "70vh", width: "100%" }}>
      <GoogleMap center={center} zoom={zoom} mapContainerStyle={{ height: "100%", width: "100%" }}>
        {points.map((p) => (
          <Marker key={p.id} position={{ lat: p.lat, lng: p.lng }} onClick={() => setActive(p)}>
            {active?.id === p.id && (
              <InfoWindow onCloseClick={() => setActive(null)} options={infoOpts}>
                <div style={cardStyle}>
                  {p.img ? <img src={p.img} alt={p.title || "Konum"} style={imgStyle} loading="lazy" /> : null}
                  <h3 style={titleStyle}>{p.title || "Konum"}</h3>
                </div>
              </InfoWindow>
            )}
          </Marker>
        ))}
      </GoogleMap>
    </div>
  );
}
